import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'
import { Button, Modal } from '@clari/ui'
import { useAuthStore } from '@/stores/authStore'
import { useSessionStore } from '@/stores/sessionStore'

/** Shown when a token refresh fails or the session goes idle. */
export function SessionExpiredModal() {
  const { t } = useTranslation('auth')
  const expired = useSessionStore((s) => s.expired)
  const reset = useSessionStore((s) => s.reset)
  const clear = useAuthStore((s) => s.clear)
  const navigate = useNavigate()

  function handleSignIn() {
    clear()
    reset()
    navigate('/login', { replace: true })
  }

  return (
    <Modal
      open={expired}
      onOpenChange={(open) => {
        if (!open) handleSignIn()
      }}
      title={t('session.expired_title')}
      description={t('session.expired_body')}
      closeLabel={t('actions.cancel')}
    >
      <div className="mt-4 flex justify-end">
        <Button onClick={handleSignIn}>{t('session.signin_again')}</Button>
      </div>
    </Modal>
  )
}
